var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 410,
    viewBox: "0 0 1440 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 410,
    fill: "#191D21"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_7741)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1302.45 30.7687C1295.6 33.3849 1290 41.5402 1290 48.87V361.13C1290 368.46 1295.6 376.615 1302.45 379.231L1516.02 460.838C1522.86 463.454 1528.47 459.607 1528.47 452.268V-42.2635C1528.47 -49.5978 1522.86 -53.4545 1516.02 -50.8338L1302.45 30.7687ZM1475.13 369.664C1475.13 376.994 1469.42 381.063 1462.5 378.685L1352.47 341.143C1345.53 338.775 1339.85 330.841 1339.85 323.502V86.5025C1339.85 79.1637 1345.53 71.2114 1352.47 68.8478L1462.5 31.319C1469.44 28.9599 1475.13 33.0286 1475.13 40.3404V369.664Z",
    fill: "#B39D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1501.82 214.858C1501.82 217.754 1495.81 220.126 1488.48 220.126H1326.87C1319.54 220.126 1313.53 217.754 1313.53 214.858C1313.53 211.962 1319.54 209.585 1326.87 209.585H1488.48C1495.81 209.585 1501.82 211.958 1501.82 214.858Z",
    fill: "#B39D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1407.67 367.729C1404.66 367.729 1402.2 361.712 1402.2 354.378V27.1514C1402.2 19.8125 1404.66 13.7998 1407.67 13.7998C1410.68 13.7998 1413.18 19.8125 1413.18 27.1514V354.378C1413.18 361.712 1410.68 367.729 1407.67 367.729Z",
    fill: "#B39D5D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_7741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 410,
    fill: "white",
    transform: "translate(1290)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.550a7001edb27805a49f4d0bf8bcd742.svg";
export { ForwardRef as ReactComponent };